import { render } from "./EditContactAddressDialog.vue?vue&type=template&id=3c3ae340&scoped=true"
import script from "./EditContactAddressDialog.vue?vue&type=script&lang=js"
export * from "./EditContactAddressDialog.vue?vue&type=script&lang=js"

import "./EditContactAddressDialog.vue?vue&type=style&index=0&id=3c3ae340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3ae340"]])

export default __exports__